import SinglePatty from '../assets/single_patty.jpg';
import ChickenBurger from '../assets/chicken_burger.jpg';
import TurkeyAvocado from '../assets/turkey_avocado.jpeg';
import IceCream from '../assets/ice_cream.jpg';
import ChipsQueso from '../assets/chips_queso.jpg';

let menu = [
  {
    course: 'Appetizers',
    items: [
      {
        name: 'Chips + Queso',
        image: ChipsQueso,
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu metus posuere, hendrerit nisl quis, posuere lectus. Integer imperdiet pellentesque est eget vehicula. Aliquam enim turpis, faucibus nec posuere id, gravida at nisi.',
        price: 6.99
      },
      {
        name: 'Fried Pickles',
        image: '',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu metus posuere, hendrerit nisl quis, posuere lectus. Integer imperdiet pellentesque est eget vehicula. Aliquam enim turpis, faucibus nec posuere id, gravida at nisi.',
        price: 6.99
      },
      {
        name: 'Onion Rings',
        image: '',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu metus posuere, hendrerit nisl quis, posuere lectus. Integer imperdiet pellentesque est eget vehicula. Aliquam enim turpis, faucibus nec posuere id, gravida at nisi.',
        price: 6.99
      },
      {
        name: 'Cheese Burger Egg Rolls',
        image: '',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu metus posuere, hendrerit nisl quis, posuere lectus. Integer imperdiet pellentesque est eget vehicula. Aliquam enim turpis, faucibus nec posuere id, gravida at nisi.',
        price: 8.99
      },
      {
        name: 'Sliders',
        image: '',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu metus posuere, hendrerit nisl quis, posuere lectus. Integer imperdiet pellentesque est eget vehicula. Aliquam enim turpis, faucibus nec posuere id, gravida at nisi.',
        price: 8.99
      },
    ]
  },
  {
    course: 'Salads',
    items: [
      {
        name: 'Caesar Salad',
        image: '',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu metus posuere, hendrerit nisl quis, posuere lectus. Integer imperdiet pellentesque est eget vehicula. Aliquam enim turpis, faucibus nec posuere id, gravida at nisi.',
        price: 7.99
      },
      {
        name: 'House Salad',
        image: '',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu metus posuere, hendrerit nisl quis, posuere lectus. Integer imperdiet pellentesque est eget vehicula. Aliquam enim turpis, faucibus nec posuere id, gravida at nisi.',
        price: 7.99
      },
      {
        name: 'Wedge Salad',
        image: '',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu metus posuere, hendrerit nisl quis, posuere lectus. Integer imperdiet pellentesque est eget vehicula. Aliquam enim turpis, faucibus nec posuere id, gravida at nisi.',
        price: 8.99
      },
      {
        name: 'Southwest Salad',
        image: '',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu metus posuere, hendrerit nisl quis, posuere lectus. Integer imperdiet pellentesque est eget vehicula. Aliquam enim turpis, faucibus nec posuere id, gravida at nisi.',
        price: 10.99
      },
      {
        name: 'Chicken Salad',
        image: '',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu metus posuere, hendrerit nisl quis, posuere lectus. Integer imperdiet pellentesque est eget vehicula. Aliquam enim turpis, faucibus nec posuere id, gravida at nisi.',
        price: 10.99
      },
    ]
  },
  {
    course: 'Burgers',
    items: [
      {
        name: 'Single Patty',
        image: SinglePatty,
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu metus posuere, hendrerit nisl quis, posuere lectus. Integer imperdiet pellentesque est eget vehicula. Aliquam enim turpis, faucibus nec posuere id, gravida at nisi.',
        price: 8.99
      },
      {
        name: 'Double Patty',
        image: '',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu metus posuere, hendrerit nisl quis, posuere lectus. Integer imperdiet pellentesque est eget vehicula. Aliquam enim turpis, faucibus nec posuere id, gravida at nisi.',
        price: 9.99
      },
      {
        name: 'Triple Patty',
        image: '',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu metus posuere, hendrerit nisl quis, posuere lectus. Integer imperdiet pellentesque est eget vehicula. Aliquam enim turpis, faucibus nec posuere id, gravida at nisi.',
        price: 10.99
      },
      {
        name: 'Chicken Burger',
        image: ChickenBurger,
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu metus posuere, hendrerit nisl quis, posuere lectus. Integer imperdiet pellentesque est eget vehicula. Aliquam enim turpis, faucibus nec posuere id, gravida at nisi.',
        price: 9.99
      },
      {
        name: 'Turkey Burger',
        image: '',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu metus posuere, hendrerit nisl quis, posuere lectus. Integer imperdiet pellentesque est eget vehicula. Aliquam enim turpis, faucibus nec posuere id, gravida at nisi.',
        price: 9.99
      },
      {
        name: 'Veggie Burger',
        image: '',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu metus posuere, hendrerit nisl quis, posuere lectus. Integer imperdiet pellentesque est eget vehicula. Aliquam enim turpis, faucibus nec posuere id, gravida at nisi.',
        price: 9.99
      },
      {
        name: 'Mushroom Burger',
        image: '',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu metus posuere, hendrerit nisl quis, posuere lectus. Integer imperdiet pellentesque est eget vehicula. Aliquam enim turpis, faucibus nec posuere id, gravida at nisi.',
        price: 9.99
      },
      {
        name: 'BBQ Burger',
        image: '',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu metus posuere, hendrerit nisl quis, posuere lectus. Integer imperdiet pellentesque est eget vehicula. Aliquam enim turpis, faucibus nec posuere id, gravida at nisi.',
        price: 9.99
      },
      {
        name: 'Asian Burger',
        image: '',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu metus posuere, hendrerit nisl quis, posuere lectus. Integer imperdiet pellentesque est eget vehicula. Aliquam enim turpis, faucibus nec posuere id, gravida at nisi.',
        price: 9.99
      }
    ]
  },
  {
    course: 'Sandwiches',
    items: [
      {
        name: 'BLT',
        image: '',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu metus posuere, hendrerit nisl quis, posuere lectus. Integer imperdiet pellentesque est eget vehicula. Aliquam enim turpis, faucibus nec posuere id, gravida at nisi.',
        price: 6.99
      },
      {
        name: 'Turkey Avocado',
        image: TurkeyAvocado,
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu metus posuere, hendrerit nisl quis, posuere lectus. Integer imperdiet pellentesque est eget vehicula. Aliquam enim turpis, faucibus nec posuere id, gravida at nisi.',
        price: 6.99
      },
      {
        name: 'Philly Cheese Steak',
        image: '',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu metus posuere, hendrerit nisl quis, posuere lectus. Integer imperdiet pellentesque est eget vehicula. Aliquam enim turpis, faucibus nec posuere id, gravida at nisi.',
        price: 7.99
      },
      {
        name: 'Cuban',
        image: '',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu metus posuere, hendrerit nisl quis, posuere lectus. Integer imperdiet pellentesque est eget vehicula. Aliquam enim turpis, faucibus nec posuere id, gravida at nisi.',
        price: 6.99
      },
      {
        name: 'Hot Dog',
        image: '',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu metus posuere, hendrerit nisl quis, posuere lectus. Integer imperdiet pellentesque est eget vehicula. Aliquam enim turpis, faucibus nec posuere id, gravida at nisi.',
        price: 4.99
      },
      {
        name: 'Chili Cheese Hot Dog',
        image: '',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu metus posuere, hendrerit nisl quis, posuere lectus. Integer imperdiet pellentesque est eget vehicula. Aliquam enim turpis, faucibus nec posuere id, gravida at nisi.',
        price: 5.99
      },
    ]
  },
  {
    course: 'Sides',
    items: [
      {
        name: 'Fries',
        image: '',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu metus posuere, hendrerit nisl quis, posuere lectus. Integer imperdiet pellentesque est eget vehicula. Aliquam enim turpis, faucibus nec posuere id, gravida at nisi.',
        price: 2.99
      },
      {
        name: 'Cheese Fries',
        image: '',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu metus posuere, hendrerit nisl quis, posuere lectus. Integer imperdiet pellentesque est eget vehicula. Aliquam enim turpis, faucibus nec posuere id, gravida at nisi.',
        price: 3.49
      },
      {
        name: 'Chili Cheese Fries',
        image: '',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu metus posuere, hendrerit nisl quis, posuere lectus. Integer imperdiet pellentesque est eget vehicula. Aliquam enim turpis, faucibus nec posuere id, gravida at nisi.',
        price: 3.99
      },
      {
        name: 'Tots',
        image: '',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu metus posuere, hendrerit nisl quis, posuere lectus. Integer imperdiet pellentesque est eget vehicula. Aliquam enim turpis, faucibus nec posuere id, gravida at nisi.',
        price: 2.99
      },
      {
        name: 'Cheese Tots',
        image: '',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu metus posuere, hendrerit nisl quis, posuere lectus. Integer imperdiet pellentesque est eget vehicula. Aliquam enim turpis, faucibus nec posuere id, gravida at nisi.',
        price: 3.49
      },
      {
        name: 'Chili Cheese Tots',
        image: '',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu metus posuere, hendrerit nisl quis, posuere lectus. Integer imperdiet pellentesque est eget vehicula. Aliquam enim turpis, faucibus nec posuere id, gravida at nisi.',
        price: 3.99
      }
    ]
  },
  {
    course: 'Desserts',
    items: [
      {
        name: 'Ice Cream',
        image: IceCream,
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu metus posuere, hendrerit nisl quis, posuere lectus. Integer imperdiet pellentesque est eget vehicula. Aliquam enim turpis, faucibus nec posuere id, gravida at nisi.',
        price: 3.99
      }
    ]
  },
]

export default menu;